import { makeStyles, mergeClasses } from '@griffel/react';
export const teachingPopoverCarouselClassNames = {
    root: 'fui-TeachingPopoverCarousel'
};
// Todo: Page change animation & styles
const useStyles = makeStyles({
    root: {}
});
/** Applies style classnames to slots */ export const useTeachingPopoverCarouselStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = mergeClasses(teachingPopoverCarouselClassNames.root, styles.root, state.root.className);
    return state;
};
